/*
 * @Descripttion: 
 * @version: 
 * @Author: 陈宇鹏
 * @Date: 2021-07-20 18:13:25
 * @LastEditors: 陈宇鹏
 * @LastEditTime: 2021-07-21 16:10:01
 */
export default
    {
        path: "/Result",
        name: "Result",
        component: () =>
            import(
            /* webpackChunkName: "Result" */ "@/pages/companyApplyResult"
            ),
        redirect: "/SettleIn",
        children: [
            {
                path: "/SettleIn",
                name: "SettleIn",
                component: () =>
                    import(
                    /* webpackChunkName: "SettleIn" */ "@/pages/companyApplyResult/SettleIn"
                    ),
            },
            {
                path: "/Certification",
                name: "Certification",
                component: () =>
                    import(
                    /* webpackChunkName: "Certification" */ "@/pages/companyApplyResult/Certification"
                    ),
            }
        ]
    }